import React from 'react';
import Table from '../Table';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary, ButtonSecondary } from '../../Buttons';

const DevicesTable = ({ devices }) => {
  const headers = [
    'Serial Number',
    'Device Name',
    'Device Model',
    'Last Connection',
    'Last Battery %',
    'Communicate',
    'Alerts',
  ];

  const navigate = useNavigate();

  // Check if there are any devices
  if (!devices || devices.length === 0) {
    return <p className="font-bold text-error">No devices available.</p>; // Display message when devices are empty
  }

  const rows = devices.map((device) => [
    device.serial,
    device.name || 'N/A',
    device.model || 'N/A',
    device.lastconn,
    device.last_battery_percent || 'N/A',
    <ButtonPrimary onClick={() => navigate(`/communicate/${device.serial}`)}>
      Communicate
    </ButtonPrimary>,
    <button
      className={`w-4 h-4 rounded-full ${
        device.has_alerts ? 'bg-red-500' : 'bg-gray-500'
      }`}
      onClick={() => navigate(`/alerts/${device.serial}`)}
      aria-label="Alerts"
    />,
  ]);

  return (
    <Table headers={headers} rows={rows} searchable={true} sortable={true} />
  );
};

export default DevicesTable;
